export default "__VITE_ASSET__DQgjnZFx__"